﻿import { create } from 'zustand';

export const useRiskMonitoringStore = create((set) => ({
    data: null,
    loading: false,
    error: null,
    lastUpdated: null,

    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setData: (data) => set({ data, lastUpdated: new Date().toISOString() }),

    reset: () => set({
        data: null,
        loading: false,
        error: null,
        lastUpdated: null,
    }),
}));
